import { Card, CardBody, CardHeader, Collapse, Input } from "reactstrap";
import { Href, SecurityTitle } from "../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAccount } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";

const Security = () => {
  const { account } = useAppSelector((state) => state.mainSidebar);
  const dispatch = useAppDispatch();
  return (
    <Card>
      <CardHeader onClick={() => dispatch(setAccount(account !== "1" ? "1" : ""))}>
        <a href={Href}>{SecurityTitle}<i className={`fa fa-angle-${account === "1" ?"up" : "down"}`} /></a>
      </CardHeader>
      <Collapse className={`${account === "1" ? "show" : ""}`}>
        <CardBody>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5>{"Show Security notification"}</h5>
            </div>
            <div className="media-right form-switch">
              <Input type="checkbox" />
            </div>
          </div>
          <p><b>{"Note : "}</b>{"turn on this setting to recive notification when a contact's security code has been changes."}</p>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default Security;
